// extracted by mini-css-extract-plugin
export default {"separator":"aJDZ4sbLBiMlBw719xHj"};